
/**
 * UpdateAvaliacaoUseCase
 */

import { IUpdateAvaliacaoUseCase } from "../../../presentation/useCases/update/update_avaliacao_use_case";
import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

export class UpdateAvaliacaoUseCase implements IUpdateAvaliacaoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) { }

  async updateAvaliacao(
    IdMedicaoTerceirizacao: number,
    Entregue: number,
    NroNotaFiscalEntregue: number,
    data: Date,
    IdFuncionarioAvaliador: number | null,
    NroNotaFiscal: string | null,
    Observacao: string | null,
    criterioItems: {
      idCriterioAvaliacaoFornecedor: number;
      idItemAvaliacaoFornecedor: number | null;
      nota: number | null;
    }[],
  ): Promise<void> {
    await this.repository.updateAvaliacao(
      IdMedicaoTerceirizacao,
      Entregue,
      NroNotaFiscalEntregue,
      data,
      IdFuncionarioAvaliador,
      NroNotaFiscal,
      Observacao,
      criterioItems,
    );
  }
}
